export const selectField = {
  dropdown: {
    'aria-label': 'toggle',
    role: 'button',
  },
  option: {
    class: ['truncate'],
  },
  overlay: {
    class: ['text-[16px] font-sans font-normal text-black', 'max-w-[75ch]'],
  },
};
